

import React, { Component } from 'react';
//import { Route, Navigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { useAuth } from './AuthProvider';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';



//This private route is for accessing any page after signing in.
const ProtectedRoute = ({ children}) => {
  const { isAuthenticated } = useAuth();    //Defined in AuthProvider.jsx

  console.log("isAuthenticated : "+isAuthenticated);

  if (isAuthenticated==='loading'){
    return <div>Loading</div>
  }

  return (
    (isAuthenticated === 'authenticated')? children : <Navigate to="/signin" />
  );

  //return isAuthenticated ? children : <Navigate to="/signin" />;
};


export default ProtectedRoute;

